import ReactDOMServer from "react-dom/server";
import { Tooltip as ReactTooltip } from "react-tooltip";
import {
  generateTooltipHtml,
  isHiddenFutureDay,
  metricConfig,
} from "./coachingHelpers";

export const Cell = ({
  athlete,
  idx,
  activeMonth,
  metric,
  isCurrentMonth,
  today,
  isPreviousMonth,
  unitSelected,
  isFromOtherOrganizationMember,
  organizationCoachId,
  referAsClients,
  t,
}) => {
  const { dataKey, getConfig } = metricConfig[metric] || metricConfig.workouts;
  const isFuture = isCurrentMonth ? idx + 1 > today : !isPreviousMonth;
  const isFutureHidden = isHiddenFutureDay({
    metric,
    idx,
    today,
    isCurrentMonth,
    isPreviousMonth,
  });
  if (!athlete[dataKey][idx] || isFutureHidden)
    return (
      <td
        className={`day ${metric === "bodyWeight" ? "bodyWeight" : ""}${idx + 1 === today && isCurrentMonth ? " today" : ""}${isFuture ? " future" : ""}`}
      />
    );
  const dateParam = `${activeMonth.format("YYYY-MM")}-${
    idx + 1 < 10 ? "0".concat(idx + 1) : idx + 1
  }`;
  const {
    className,
    cycle,
    hRef,
    displayValue,
    displayClassName,
    displayStyle,
  } = getConfig({
    athlete,
    idx,
    activeMonth,
    isCurrentMonth,
    today,
    isPreviousMonth,
    unitSelected,
    isFromOtherOrganizationMember,
    organizationCoachId,
    dateParam,
  });

  return (
    <td
      data-tooltip-html={ReactDOMServer.renderToStaticMarkup(
        generateTooltipHtml(
          athlete,
          cycle,
          idx,
          activeMonth,
          athlete[dataKey][idx].value || athlete[dataKey][idx].status || false,
          referAsClients,
          metric,
          unitSelected,
          today,
          t
        )
      )}
      data-html={true}
      className={`day ${metric === "bodyWeight" ? "bodyWeight" : ""} ${idx + 1 === today && isCurrentMonth ? "today" : ""}${isFuture ? " future" : ""}`}
      key={`athlete-${athlete._id}-day-${idx}`}
      data-tooltip-id={`athlete-${athlete._id}-day-${idx}`}
    >
      {displayValue !== undefined ? (
        <a href={hRef} className={displayClassName} style={displayStyle}>
          {displayValue}
        </a>
      ) : (
        // biome-ignore lint/a11y/useAnchorContent: false positive
        <a
          className={className}
          href={hRef}
          onClick={(e) => !hRef && e.preventDefault()}
        />
      )}
      <ReactTooltip
        id={`athlete-${athlete._id}-day-${idx}`}
        opacity={1}
        float
      />
    </td>
  );
};
